import { useEffect } from "react";

export const useCloseOnEscape = (handleClose?: () => void) => {
  useEffect(() => {
    if (!handleClose) {
      return;
    }

    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.code === "Escape") {
        handleClose();
      }
    };

    document.addEventListener("keydown", closeOnEscape);

    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [handleClose]);
};
